<template>
  <div style="width:100%;">
    <vue-particles
      style="background-image:url('./static/img/wallpaper.jpg');width:100%;background-size:cover;"
      color="#dedede"
      :particleOpacity="0.3"
      :particlesNumber="110"
      shapeType="circle"
      :particleSize="3"
      linesColor="#dedede"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.5"
      :linesDistance="70"
      :moveSpeed="7"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push"
    ></vue-particles>

    <transition name="scale-transition">
      <v-card
        v-if="logshow"
        class="elevation-12"
        style="position:fixed;top:125px;left:calc(50% - 200px);
    margin:auto;width:400px;opacity:0.9;"
      >
        <v-toolbar dark color="primary">
          <v-toolbar-title class="white--text"
            >MetadminJS v.2019</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn slot="activator" icon large target="_blank">
              <v-icon large>https</v-icon>
            </v-btn>
            <span>Adekz TI</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-text-field
              prepend-icon="person"
              name="login"
              label="Usuário"
              v-model="login"
              type="text"
            ></v-text-field>
            <v-text-field
              id="password"
              prepend-icon="lock"
              name="password"
              v-model="senha"
              label="Senha"
              type="password"
            ></v-text-field>
          </v-form>

          <div class="danger-alert" v-html="error" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="doLogin()">Entrar</v-btn>
        </v-card-actions>
      </v-card>
    </transition>
  </div>
</template>

<script>
/* eslint-disable */

try {
  var Authentication = require("@/services/authentication").default;
} catch (err) {
  var Authentication = require("@/framework/services/authentication").default;
}


export default {
  data() {
    return {
      login: "",
      senha: "",
      error: null,
      logshow: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.logshow = true;
    }, 800);
  },
  methods: {
    async doLogin() {
      try {
        const response = await Authentication.login({
          login: this.login,
          senha: this.senha
        });
        this.$store.dispatch("setToken", response.data.token);
        this.$store.dispatch("setUser", response.data.user);

        if (this.$socket) {
          await this.$socket.client.close();
          this.$socket.client.open();
        }
        this.$router.push({
          name: "adminpage-cockpit"
        });
      } catch (error) {
        this.error = error.response.data.error;
      }
    }
  },
  components: {}
};
</script>

<style></style>
